import api from "../api/axiosInstance";

const consolidationService = {
  getAll: (params) => api.get("/consolidations", { params }),
  getOne: (id) => api.get(`/consolidations/${id}`),
  requestForShipment: (shipmentId, consolidationId) =>
    api.post(`/consolidations/shipment/${shipmentId}`, consolidationId ? { consolidationId } : {}),
  addItem: (shipmentId, itemId, consolidationId) =>
    api.post("/consolidations/item", { shipmentId, itemId, consolidationId }),
  removeItem: (consolidationId, shipmentId, itemId) =>
    api.delete(`/consolidations/${consolidationId}/items/${shipmentId}/${itemId}`),
  cancel: (id) => api.post(`/consolidations/${id}/cancel`),
  updatePreference: (id, holdPreference) =>
    api.patch(`/consolidations/${id}/preference`, { holdPreference }),
  assignSailing: (id, sailingId) => api.post(`/consolidations/${id}/assign-sailing`, { sailingId }),
  scheduleDelivery: (id) => api.post(`/consolidations/${id}/schedule-delivery`),
  getSettings: () => api.get("/consolidations/settings"),
  updateSettings: (data) => api.patch("/consolidations/settings", data),
};

export default consolidationService;
